import $ from 'jquery';

export class TimelineFilter {
    constructor($element) {
        this.$element = $element;
        this.buttons = $('.timeline-category-filter__button', this.$element);
        this.reset = $('.timeline-category-filter__reset');
        this.activeCategories = [];
        const _self = this;

        this.buttons.on('click', function(e) { _self.buttonHandleClick(e); });
        this.reset.on('click', function(e) { _self.resetHandleClick(e); });
    }

    buttonHandleClick(e) {
        const cat = this.readCategoryFromButton($(e.currentTarget));
        if (this.activeCategories.includes(cat)) {
            this.removeActiveCategory(cat);
            $(e.currentTarget).removeClass('active');
        } else {
            this.addActiveCategory(cat); 
            $(e.currentTarget).addClass('active');
        }

        if (this.isActive()) {
            this.reset.fadeIn();
        } else {
            this.reset.fadeOut();
        }
    }

    resetHandleClick(e) { 
        this.activeCategories = [];
        this.buttons.removeClass('active');
        this.$element.trigger('filterChange', [this.activeCategories]);
    }

    addActiveCategory(category) {
        if (this.activeCategories.includes(category)) return false;

        this.activeCategories.push(category);

        this.$element.trigger('filterChange', [this.activeCategories]);
        return true;
    }

    removeActiveCategory(category) {
        if (!this.activeCategories.includes(category)) return false;

        this.activeCategories = this.activeCategories.filter(function(item) {
            return item !== category;
        })

        this.$element.trigger('filterChange', [this.activeCategories]);
        return true;
    }

    readCategoryFromButton($button) {
        return $button.data('category');
    }

    isActive() {
        return this.activeCategories.length > 0;
    }

}